import * as actions from './actions'

export default actions
export reducer from './reducer'
export withNotifications from './components/withNotifications'
export Notifications from './components/Notifications'
export * as actionTypes from './actionTypes'



// WEBPACK FOOTER //
// ./src/modules/notification/index.js